import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch4_p06} from "../../../layouts/ch4_p06/ch4_p06"

export class Chapter4Page6 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly holly = list(()=>this.addChild(new SceneSprite()));

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch4_p06/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch4_p06/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch4_p06.call(this);

        this.holly[0].visible = true;
        this.holly[1].visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        const t = new TimelineLite();
        t.call(()=>{
            this.holly[0].FadeOut();
            this.holly[1].FadeIn();
        });
        t.call(()=>{
            super.onAnimateInComplete();
        }, undefined, undefined, "+=1.5");
        t.call(()=>{
            this.gotoNextState({transition: "up"});
        }, undefined, undefined, "+=1.5");
        t.delay(0.5);
    }
}